import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { EmptyInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-info-box';
import styled from 'styled-components';

export function EmptyStateUnweightedPortfolio() {
  return (
    <EmptyInfoBox title="No data available" topColor={BouColor.IMPACT_NEGATIVE_PURPLE}>
      <>
        <Text>
          This is an unweighted portfolio where portfolio level scores are not calculated. See the list of underlying
          holdings below.
        </Text>
      </>
    </EmptyInfoBox>
  );
}

const Text = styled.div``;
